import { render, staticRenderFns } from "./emptyView.vue?vue&type=template&id=39c074b2&scoped=true"
import script from "./emptyView.vue?vue&type=script&lang=js"
export * from "./emptyView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39c074b2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/gkzy/Desktop/achievement-transform-system/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('39c074b2')) {
      api.createRecord('39c074b2', component.options)
    } else {
      api.reload('39c074b2', component.options)
    }
    module.hot.accept("./emptyView.vue?vue&type=template&id=39c074b2&scoped=true", function () {
      api.rerender('39c074b2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/emptyView.vue"
export default component.exports